// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-6beed8bc] {\n  /*84 = navbar + tags-view = 50 +34 */\n  min-height: calc(100vh - 84px);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
